import { useTranslation } from 'react-i18next';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import About from '../../modals/components/About/About';

export default function AboutPage() {
  const { t } = useTranslation();
  return <PageTemplate title={t('about.title')} content={<About />} />;
}
